import React from "react";
import "./Publications.css";
import { MdArticle } from "react-icons/md";
import Footer from "./Footer";

const publications = () => {
	return (
		<>
			<div className="grantsawards-container">
				<h2>
					<MdArticle /> Publications
				</h2>
				<div className="grantsawards-container_content">
					<div className="grantsawards_items">
						<p>
							<span>Hanna Lavalle, M. I., Gomez Salgado, A. A., & Marquez Garcia, L. A.</span> (2024). Sistema tutor inteligente basado en la personalización del aprendizaje para la
							enseñanza de protocolos de atención en salud. Revista Colombiana de Tecnologias de Avanzada (RCTA), 2(44), 45–54. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.24054/rcta.v2i44.2866">
								https://doi.org/10.24054/rcta.v2i44.2866
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Gomez, A. A., & Sun, R.</span> (2024). A “Rational” Framework for Self-Control. In Proceedings of the Annual Meeting of the Cognitive Science Society (Vol. 46).{" "}
							<br />
							<a target="_blank" rel="noreferrer noopener" href="https://acortar.link/8jKf6q">
								https://escholarship.org/18c53299540=sgrhdd
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Gomez, A., & Marquez, L.</span> (2021). Representation of the Problem-Solving Process of the Tower of Hanoi using Fuzzy Cognitive Maps. 2021 IEEE 20th International
							Conference on Cognitive Informatics & Cognitive Computing (ICCI* CC), 147-152. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1109/ICCICC53683.2021.9811321">
								https://doi.org/10.1109/ICCICC53683.2021.9811321
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Marquez, L., Zapa, H., & Gomez, A.</span> (2021). Design of a Cognitive Control Mechanism for a Goal-based Executive Function of a Cognitive System. Proceedings of
							the Ninth Goal Reasoning Workshop. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://bit.ly/3ULb0UW">
								https://bit.ly/3ULb0UW
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Gomez, A.</span> (2021). Design of a Self-Control Mechanism for a GDA-Based Tutor Module of an Intelligent Tutoring System. Proceedings of the Ninth Goal Reasoning
							Workshop. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://bit.ly/4bDlmMK">
								https://bit.ly/4bDlmMK
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Gomez, A., Marquez, L., Zapa, H., & Florez, M.</span> (2021). GDA-Based Tutor Module of an Intelligent Tutoring System for the Personalization of Pedagogic
							Strategies. Emerging Trends in Intelligent and Interactive Systems and Applications. Proceedings of the 5th International Conference on Intelligent, Interactive Systems and
							Applications (IISA2020), 742-750. Springer International Publishing. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1007/978-3-030-63784-2_92">
								https://doi.org/10.1007/978-3-030-63784-2_92
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Cogollo, Y., Salgado, A., & Garcia, L.</span> (2020). Intelligent Tutoring Systems and Planning Techniques: A Systematic Review. Acta ScientiÆ InformaticÆ, 4(4), 6-6.{" "}
							<br />
							<a target="_blank" rel="noreferrer noopener" href="https://bit.ly/3wkqiWy">
								https://bit.ly/3wkqiWy
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Espinosa-Lopez, A., Gomez-Salgado, A., & Lorduy-Arellano, D.</span> (2020). CARINA-based Cognitive Agent for Factoid Wh-Questions Generation in EFL. International
							Journal on Advanced Science, Engineering, and Information Technology. 10(5), 1852-1859. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.18517/ijaseit.10.5.10138">
								https://doi.org/10.18517/ijaseit.10.5.10138
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Galeano, R., Salgado, A., & Arellano, D.</span> (2020). Metacognitive Strategies and Learning Quality: A Systematic Mapping Study. International Association for
							Development of the Information Society 48. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://bit.ly/48lzneY">
								https://bit.ly/48lzneY
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Gomez, A., Florez, E., & Marquez, L.</span> (2019). Design of the Tutor Module for an Intelligent Tutoring System (ITS) Based on Science Teachers’ Pedagogical Content
							Knowledge (PCK). International Congress on Education and Technology in Sciences 141-157. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1007/978-3-030-45344-2_12">
								https://doi.org/10.1007/978-3-030-45344-2_12
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Florez, Y., Jerónimo, J., Castillo, M., & Gomez, A.</span> (2019). User-Based Cognitive Model in NGOMS-L for the Towers of Hanoi Algorithm in the Metacognitive
							Architecture CARINA. International Conference on Advances in Emerging Trends and Technologies. 473-484. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1007/978-3-030-32022-5_44">
								https://doi.org/10.1007/978-3-030-32022-5_44
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Garcia, L., & Salgado, A.</span> (2019). ANN-Based Model for Simple Grammatical Cases Teaching in Spanish Language. International Conference on Advances in Emerging
							Trends and Technologies. 442-453. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1007/978-3-030-32022-5_41">
								https://doi.org/10.1007/978-3-030-32022-5_41
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Caro, M., Josyula, D., Madera, D., Kennedy, C., & Gomez, A.</span> (2019). The CARINA Metacognitive Architecture. International Journal of Cognitive Informatics and
							Natural Intelligence (IJCINI), 13(4), 71-90. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.4018/IJCINI.2019100104">
								https://doi.org/10.4018/IJCINI.2019100104
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Nisperuza, E., & Salgado, A. (2019).</span> Science Teachers Perceptions on their Pedagogical Content Knowledge (PCK). In CISETC 2019 International Congress on
							Educational and Technology in Sciences. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://ceur-ws.org/Vol-2555/paper26.pdf ">
								https://ceur-ws.org/Vol-2555/paper26.pdf
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Lopez, A., Salgado, A., & Calao, Y.</span> (2018). Natural Language for Factoid- WH in English as a Foreign Language. Acta ScientiÆ InformaticÆ, 2(2), 5-5. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://bit.ly/48n3hiW">
								https://bit.ly/48n3hiW
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Gomez, A., Caro, M., Solano, A., & Vega, Y.</span> (2018). Trends of educational informatics in Latin America. International Journal of Software Science and
							Computational Intelligence (IJSSCI), 10(1), 80-87. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.4018/IJSSCI.2018010106">
								https://doi.org/10.4018/IJSSCI.2018010106
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Madera-Doval, D., Caro-Piñeres, M., Gomez-Salgado, A., Cardozo-Soto, A., & Jimenez-Builes, J.</span> (2018). Design of metacognitive expectations of cognitive
							functions through ontological representations. Dyna, 85(206), 194-201. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.15446/dyna.v85n206.71687">
								https://doi.org/10.15446/dyna.v85n206.71687
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Caro, M., Josvula, D., Gomez, A., & Kennedy, C.</span> (2018, July). Introduction to the CARINA metacognitive architecture. 2018 IEEE 17th International Conference on
							Cognitive Informatics & Cognitive Computing (ICCI* CC), 530-540. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1109/ICCI-CC.2018.8482051">
								https://doi.org/10.1109/ICCI-CC.2018.8482051
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Madrigal, M., Salgado, A., & Piñeres, M.</span> (2018). Validación del proceso basado en M++ de las Trazas de Razonamiento Introspectivas de la función cognitiva
							percepción de la arquitectura metacognitiva CARINA. Teknos Revista Científica, 18(2), 54-62. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.24054/rcta.v2i44.2866">
								https://doi.org/10.24054/rcta.v2i44.2866
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Lopez, A., Calao, Y., Salgado, A., & Piñeres, M.</span> (2018). Validación de un modelo cognitivo basado en M++ para la generación de preguntas Factoid-Wh. Teknos
							Revista Científica, 18(2), 11-20.
							<br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.25044/25392190.972">
								https://doi.org/10.25044/25392190.972
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Gomez, A., & Caro, M.</span> (2018) Meta-Modeling Process of Pedagogical Strategies in Intelligent Tutoring Systems. 2018 IEEE 17th International Conference on
							Cognitive Informatics & Cognitive Computing (ICCI* CC). IEEE, 2018. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1109/ICCI-CC.2018.8482046">
								https://doi.org/10.1109/ICCI-CC.2018.8482046
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Florez, M., Gomez, A., & Caro, M.</span> (2018). Formal Representation of Introspective Reasoning Trace of a Cognitive Function in CARINA. 2018 IEEE 17th
							International Conference on Cognitive Informatics & Cognitive Computing (ICCI* CC). IEEE, 2018. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1109/ICCI-CC.2018.8482053">
								https://doi.org/10.1109/ICCI-CC.2018.8482053
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Jeronimo, A., Caro, M., & Gomez, A.</span> (2018) Formal Specification of cognitive models in CARINA. 2018 IEEE 17th International Conference on Cognitive Informatics
							& Cognitive Computing (ICCI*CC). IEEE, 2018. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1109/ICCI-CC.2018.8482062">
								https://doi.org/10.1109/ICCI-CC.2018.8482062
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Olier, A., Gomez, A., & Caro, M.</span> Cognitive Modeling Process in Metacognitive Architecture CARINA. 2018 IEEE 17th International Conference on Cognitive
							Informatics & Cognitive Computing (ICCI* CC). IEEE, 2018. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1109/ICCI-CC.2018.8482090">
								https://doi.org/10.1109/ICCI-CC.2018.8482090
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Caro, M., Gomez, A., & Giraldo, J.</span> (2017). Algorithmic knowledge profiles for introspective monitoring in artificial cognitive agents. 2017 IEEE 16th
							International Conference on Cognitive Informatics & Cognitive Computing (ICCI* CC). IEEE, 2017. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1109/ICCI-CC.2017.8109792">
								https://doi.org/10.1109/ICCI-CC.2017.8109792
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Quiceno, A., Salgado, A., & Caro, M.</span> (2017). Design and Implementation of a Teaching Tool for Introduction to object-oriented programming. IEEE Latin America
							Transactions, 15(1), 97-102. <br />
							<a target="_blank" rel="noreferrer noopener" href="https://doi.org/10.1109/TLA.2017.7827913">
								https://doi.org/10.1109/TLA.2017.7827913
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Bernal, D., Miranda, R., Gomez, A., & Caro, M.</span> (2017). Sinopsis de metodologías y modelos de software educativo. Acta ScientiÆ InformaticÆ, 1(1). <br />
							<a target="_blank" rel="noreferrer noopener" href="https://bit.ly/3I5ouDz">
								https://bit.ly/3I5ouDz
							</a>
						</p>
					</div>
					<div className="grantsawards_items">
						<p>
							<span>Soto, A., Madera, D., Gomez, A., & Caro, M.</span> (2017). An overview about metacognitive expectations in a cognitive agent. Acta ScientiÆ InformaticÆ, 1(1). <br />
							<a target="_blank" rel="noreferrer noopener" href="https://bit.ly/3wixG4X">
								https://bit.ly/3wixG4X
							</a>
						</p>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default publications;
